import ConfirmDeleteDialog from "../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog";
import { ReminderDatabase } from "../../../../types";
import useDeleteReminder from "../../api/useDeleteReminder";

type Props = {
  reminder: ReminderDatabase;
  onClose: () => void;
}

export default function DeleteReminderModal(props: Props) {
  const { mutateAsync } = useDeleteReminder();

  return (
    <ConfirmDeleteDialog
      title="Supprimer le rappel"
      confirmLabel="Supprimer le rappel"
      onConfirm={() => mutateAsync(props.reminder.id)}
      onClose={props.onClose}
    >
      Êtes-vous sûr de vouloir supprimer le rappel « {props.reminder.title} » ?
    </ConfirmDeleteDialog>
  );
}
